import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = resource => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/security/buddy-matches/${resource.id}/edit`} />,
    <MenuItem primaryText='User 1' key='user-1' value={`/security/users/${resource.user_id_low}/edit`} />,
    <MenuItem primaryText='User 2' key='user-2' value={`/security/users/${resource.user_id_high}/edit`} />
  ]
}

export default buildMenuItems
